import HwpTvApi, { EVENTS } from './hwpTvApi';
import { getLogger } from './logging/logger';
import PopUpManager from './manager/popUpManager';
import Readyable from './readyable';

const logger = getLogger('HwpTvDispatcher');

/**
 * @typedef {import('./hwpTvApi').RewardData} RewardData
 */

class HwpTvDispatcher extends Readyable {
	constructor() {
		super();
		logger.log('[constructor]');

		HwpTvApi.on(EVENTS.apiUpdate, (/** @type {RewardData[]} */ rewards) =>
			rewards.forEach((reward) => this.onReward(reward)),
		);

		this.onReadyResolve(this);
	}

	/**
	 * @param {RewardData} rewardData
	 */
	onReward(rewardData) {
		logger.log(`[${this.onReward.name}]`, { ...rewardData });

		const { games, popups } = rewardData;

		if (popups?.length) {
			popups.forEach((data) => PopUpManager.displayDialog(data));
		}

		if (games?.length) {
			games.forEach((gameData) => PopUpManager.launchGame(gameData));
		}
	}
}

export default new HwpTvDispatcher();
